// 平台管理
export const DISTRIBUTIONLIST = 'DISTRIBUTIONLIST' // 仓点数据列表
export const DISTRIBUTIONADD = 'DISTRIBUTIONADD' // 新增仓点数据
export const DISTRIBUTIONDEL = 'DISTRIBUTIONDEL' // 删除仓点数据
export const DISTRIBUTIONUPDATE = 'DISTRIBUTIONUPDATE' // 编辑仓点数据
export const DISTRIBUTIONALL = 'DISTRIBUTIONALL' // 仓点下拉框
export const DISTRIBUTIONISUSE = 'DISTRIBUTIONISUSE' // 禁用仓点数据



// WEBPACK FOOTER //
// ./src/store/distriBution/types.js